import { render, staticRenderFns } from "./HealthScoreBadge.vue?vue&type=template&id=3304476e&scoped=true&lang=pug"
import script from "./HealthScoreBadge.vue?vue&type=script&lang=js"
export * from "./HealthScoreBadge.vue?vue&type=script&lang=js"
import style0 from "./HealthScoreBadge.vue?vue&type=style&index=0&id=3304476e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3304476e",
  null
  
)

export default component.exports